export const STATE = {
	IDLE:      'idle',
	CREATED:   'created',
	RUNNING:   'running',
	COMPLETED: 'completed',
	FAILED:    'failed',
	CANCELLED: 'cancelled',
};
